import { InjectionToken } from "@angular/core";
import { FilterConfigOperator } from "@softline/application";

export const SOFTLINE_REGISTRATION_FILTER_OPERATOR_COMPONENT = new InjectionToken<FilterConfigOperator[]>('SOFTLINE_REGISTRATION_FILTER_OPERATOR_COMPONENT')

export const SOFTLINE_DATA_FILTER_VALUES = new InjectionToken<unknown[]>('SOFTLINE_DATA_FILTER_VALUES');
